import { render, staticRenderFns } from "./tab-schedules-available.vue?vue&type=template&id=203cd2e4"
import script from "./tab-schedules-available.vue?vue&type=script&lang=js"
export * from "./tab-schedules-available.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports